import moment from 'moment';
import { useState } from 'react';
import TableCompHead from '../../../../../components/ui/TableCompHead';
import DatePickerMui from '../../../../../components/common/DatePickerMui';
import formatDate from '../../../../../components/common/formatDate';
import CustomSelect from '../../../../../components/common/SelectField';
import { MenuItem } from '@mui/material';

interface IProps {
  moduleData: any;
  setControllerRender: any;
  isView: boolean;
}

const toolsArray = Array.from(
  { length: 5 - 5 },
  (_, index) => `Tool ${index + 1}`,
);
const theadData = [
  'S.N',
  'Shift',
  'Shift Old',
  'M/C Detail',
  'Operator Name',
  'Component',
  'Operation',
  'Running Time',
  ...toolsArray,
  'Target',
  'Actual Prod.',
  'Ok Qty.',
  'Reason Of loss',
  'Rejection',
  'Rejection Details',
];
const THead = ({ moduleData, isView, setControllerRender }: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <thead>
      <TableCompHead
        colSpan={18}
        rowSpan={3}
        labels={['DOC NO', 'Rev No', 'Date']}
        values={['FM-PROD-01', '02', '13.10.2020']}
        heading="Department - Press Shop "
      />{' '}
      <tr>
        <th colSpan={4} align="left">
          Daily Production Date :
          {isView ? (
            formatDate(moduleData.dailyProduction_date)
          ) : (
            <DatePickerMui
              label=""
              value={moment(moduleData.dailyProduction_date)}
              onChange={(date) => {
                moduleData.dailyProduction_date = date;
                setRender((prev) => !prev);
              }}
            />
          )}{' '}
        </th>
        <th colSpan={1} align="left">
          Shift :
          {isView ? (
            moduleData.shift
          ) : (
            <CustomSelect
              name="shift"
              value={moduleData.shift || ''}
              onChange={(e) => {
                moduleData.shift = e.target.value;
                setControllerRender((prev: any) => !prev);
              }}
            >
              <MenuItem value="A">A</MenuItem>
              <MenuItem value="B">B</MenuItem>
            </CustomSelect>
          )}
        </th>
        <th colSpan={13}></th>
      </tr>
      <tr>
        {theadData.map((heading, index) => (
          <th
            key={heading + index}
            colSpan={heading === 'Running Time' ? 2 : 1}
            rowSpan={heading === 'Running Time' ? 1 : 2}
          >
            {heading}
          </th>
        ))}
        <th colSpan={3} rowSpan={2}>
          Remarks
        </th>
      </tr>
      <tr>
        <th>Start</th>
        <th>Stop</th>
      </tr>
    </thead>
  );
};

export default THead;
